export class RegistrationValidatorController {

  constructor($scope, $location, $timeout) {
    $scope.vm = this;
    this.scope = $scope;
    this.location = $location;
    this.timeout = $timeout;

    this.init();
  }

  init() {
    this.timeout(() => {
      this.location.path("/homerd");
    }, 5000);
  }
}
